export const toggleStickyDrawer = (payload) => ({
  type: "TOGGLE_STICKY_DRAWER",
  payload
})
